import { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
const useAppDispatch = () => useDispatch();
const useAppSelector = useSelector;
const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export { useAppDispatch, useAppSelector, usePrevious };
//# sourceMappingURL=hooks.js.map
